import { ErrorMessage, StyledInput, Wrapper } from "./element";
import { OptionProps } from "./types";

const OptionItemWithInput = ({
  label,
  placeholder,
  value,
  handleChange,
  onPressEnter,
  inputError,
}: OptionProps) => {
  return (
    <>
      <Wrapper>
        {label}
        <StyledInput
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onPressEnter={onPressEnter}
          allowClear
        />
      </Wrapper>
      {inputError !== "" && <ErrorMessage>{inputError}</ErrorMessage>}
    </>
  );
};

export default OptionItemWithInput;
